import { PaginationAndFilter } from 'src/interfaces/common/pagination';
import { BasicProfile, Dealer, DocumentDetails, FileModel } from 'src/interfaces/new-dealers/dealer';
import axiosClient from 'src/utils/axios-client';
import { APIConfig } from '../../config';

class DealerApi {
  private channelPartnerApiUrl = APIConfig.channelPartnerApiUrl;

  async addNewDealer(attributes: BasicProfile): Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .post(`${this.channelPartnerApiUrl}dealer`, attributes)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getDealerProfile(): Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.get(`${this.channelPartnerApiUrl}dealer/profile`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getDealerById(channelPartnerId: string):
  Promise<{ responseData: Dealer | any, statusCode: number }> {
    try {
      const res = await axiosClient
        .get(`${this.channelPartnerApiUrl}dealer/getById/${channelPartnerId}`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async updateBasicDetails(basicProfile: BasicProfile, dealerId: string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}dealer/${dealerId}/basicDetails`, basicProfile)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      try {
        return Promise.resolve({
          responseData: error.response.data,
          statusCode: error.response.status
        });
      } catch {
        return Promise.resolve({
          responseData: {
            message: 'Something went wrong. Please try again later.'
          },
          statusCode: 500
        });
      }
    }
  }

  async addDocument(document: DocumentDetails, dealerId: string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}dealer/${dealerId}/document`, document)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      try {
        return Promise.resolve({
          responseData: error.response.data,
          statusCode: error.response.status
        });
      } catch {
        return Promise.resolve({
          responseData: {
            message: 'Something went wrong. Please try again later.'
          },
          statusCode: 500
        });
      }
    }
  }

  async deleteDocument(id: string, dealerId: string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .delete(`${this.channelPartnerApiUrl}dealer/${dealerId}/document/${id}`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async addProfilePhoto(document: FileModel, dealerId: string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}dealer/${dealerId}/basicDetails`, { profileImage: document })
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async updateDealerStatus(attributes: any): Promise<{ responseData: any, statusCode: number }> {
    try {
      const body = {
        ...attributes,
      };

      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}dealer/status`, body)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getDealersByPaginationAndFilters(options: PaginationAndFilter):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .post(`${this.channelPartnerApiUrl}dealer/getByPaginationAndFilter`, options)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async verifyDealer(authChallengeResponse: string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const authChallengeResponses = authChallengeResponse.split('&');

      const attributes = {
        username: authChallengeResponses[0],
        authChallenge: authChallengeResponses[1],
      };
      console.log(attributes);

      const res = await axiosClient
        .post(`${this.channelPartnerApiUrl}dealer/verify`, attributes)
        .then((response) => response).catch((error) => error);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }
}

export const dealerApi = new DealerApi();
